import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_CONDITIONAL_KICKSTART = defineFcm('starfish_conditional_kickstart')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig({
		owner: 'squad-starfish',
		scope: ['comms-stack', 'corgi-front-end', 'promotion-service'],
		context: 'Conditional Kickstart',
		description:
			'Feature toggle for the conditional kickstart UI in the starter onboarding flow that is tied to an experiment `starfishConditionalKickstart`',
		mergeLogic: 'Needs combination of both country code and locale to be enabled',
		import: false,
	});
